if (!customElements.get('collapsible-tabs')) {
  customElements.define(
    'collapsible-tabs',
    class CollapsibleTabs extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.detailsElements = this.querySelectorAll('.accordion-details');
        this.colorScheme = this.dataset.colorScheme;

        // --- [ADDED LINES] ---
        // Force every details to be open on page load
        // and run handleOpen() so the "open-state" logic is applied.
        if (this.detailsElements.length > 0) {
          this.detailsElements.forEach((details) => {
            details.setAttribute('open', '');
            details.setAttribute('aria-expanded', 'true');
            this.handleOpen(details);

            // Keep the original logic in case the user toggles
            details.addEventListener('toggle', this.onToggle.bind(this));
          });
        }
        // --- [END ADDED LINES] ---
      }

      onToggle(event) {
        const activeDetails = event.target;
        if (activeDetails.open) {
          this.handleOpen(activeDetails);
        } else {
          this.handleClose(activeDetails);
        }
      }

      handleOpen(details) {
        const parent = details.closest('.accordion-item');
        // Original code
        if (parent.classList.contains('accordion-card')) {
          parent.classList.add(this.colorScheme);
        }

        // --- [ADDED LINES] ---
        // Apply "open-state" class for custom styling
        parent.classList.remove('closed-state');
        parent.classList.add('open-state');
        // --- [END ADDED LINES] ---
      }

      handleClose(details) {
        const parent = details.closest('.accordion-item');
        // Original code
        if (parent.classList.contains('accordion-card')) {
          parent.classList.remove(this.colorScheme);
        }

        // --- [ADDED LINES] ---
        // Apply "closed-state" class for custom styling
        parent.classList.remove('open-state');
        parent.classList.add('closed-state');
        // --- [END ADDED LINES] ---
      }
    }
  );
}
